import * as React from 'react';
import { renderDefinedTrue } from '../../../utils/react';

export interface Props {
  style?: any;
  for?: any;
  children?: any;
}

export const InputLabel = (props: Props) => {
  return renderDefinedTrue(props.children, () => (
    <label className={'inputLabel'} style={props.style}>
      {props.children}
    </label>
  ));
};
